<template>
  <div id="app" v-if="loggedIn">
    <div id="route-container">
      <transition name="page" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </div>
  <div id="login" v-else>
    <div id="login-form">
      <div id="login-input">
        <div class="input-container">
          <label>用戶密碼</label>
          <input type="password" id="password" v-model="password" />
        </div>
      </div>
      <a id="login-button" @click="login" href="javascript: void(0)" :class="loading ? 'loading' : error ? 'error' : ''">
        <span v-if="!loading">{{ error ? error_message : '登入' }}</span>
        <div class="lds-ring" v-else><div></div><div></div><div></div><div></div></div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      username: null,
      loading: false,
      error: false,
      error_message: null
    }
  },
  computed: mapGetters([ "loggedIn" ]),
  methods: {
    login() {
      if (this.password) {
        this.error = false;
        
        if (this.password === "wigwam123456789") {
          this.$store.commit("setLogin", { expires: Date.now() + 120 * 60 * 1000 })
        } else {
          this.error = true;
          this.error_message = "登入失敗 請重試"
        }
      } else {
        this.error = true
        this.error_message = "請輸入密碼"
      }
    }
  }
}
</script>

<style scoped>
.page-enter-active {
  transition: opacity .3s ease-out, transform .3s ease-out;
}
.page-leave-active {
  transition: all 0.15s ease-out;
}
.page-enter {
  opacity: 0;
  transform: translateY(10%);
}
.page-leave-to {
  opacity: 0;
  transform: translateY(10%);
}

.lds-ring {
  width: 50px;
  height: 50px;
}
.lds-ring div {
  width: 36px;
  height: 36px;

  border-width: 3px;
  border-color: grey transparent transparent transparent;
}

#app, #login {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#app {
  height: 100%;
  width: 100%;
  text-align: center;
  color: #2c3e50;

  display: flex;
  flex-flow: column;

  overflow: hidden;
}

#login {
  width: 100%;
  height: 100%;
  background: #151515;
  display: flex;

  align-items: center;
  justify-content: center;
}
#login-form {
  display: flex;
  flex-flow: column;

  margin: 30px;
  max-width: 575px;
  width: 100%;

  background: #292929;
  border-radius: 7px;

  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

  overflow: hidden;
}
#login-input {
  flex: 1;
  padding: 5px 0 30px;
}
#login-button {
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  background: #383838;

  color: white;
}
#login-button.loading {
  pointer-events: none;
  background: rgb(240,240,240);
}
#login-button.error {
  background: #ce1515;
}
#route-container {
  height: 100%;
  width: 100%;
}
nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;

  display: flex;
  padding: 0 3px;
}
.nav-item-container {
  flex: 1 1;
  padding: 0 10px 50px;
}
.nav-item-container > .nav-item {
  color: white;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 22px;
}
</style>

<style>
* {
  margin: 0;
  padding: 0;
  outline: none;
}
html, body {
  height: 100%;
  width: 100%;
}

.input-container {
  padding: 8px 16px;
  display: flex;
  align-items: center;
}
.input-container label {
  white-space: nowrap;

  color: rgb(111, 111, 111);
  font-size: 13px;
  display: block;

  margin-right: 16px;
}
.input-container input {
  flex: 1;

  outline: none;
  border-radius: 6px;
  border: 1px solid lightgrey;

  font-size: 15px;
  padding: 10px;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid black;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: black transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
